// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import { ensureSafeComponent } from '@embroider/util';
import GeneralDropdownsOtaDropdownClass from 'lumen/components/general/dropdowns/ota-dropdown-class';

export type Dropdown = {
  toggleDropdown: () => void;
};

/*
interface GeneralDropdownsDropdownYieldSignature {
  Args: {
    dropdownClass?: string;
    dropdownClassName?: string;
    extra?: unknown;
    label?: string;
    onCancel?: () => unknown;
    selected: unknown;
    triggerComponent: unknown;
  };
  Blocks: {
    default: [Dropdown];
  };
  Element: HTMLElement;
}
*/

export default class GeneralDropdownsDropdownYield extends GeneralDropdownsOtaDropdownClass {
  publicAPI = null;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get dropdownClass() {
    return this.args.dropdownClass ?? '.dropdown-yield';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get dropdownClassName() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.dropdownClassName ?? 'dropdown-yield';
  }

  constructor() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);
    // @ts-expect-error: Incorrect type
    this.publicAPI = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      toggleDropdown: this.toggleDropdown,
    };
  }

  <template>
    <div class="dropdown">
      {{! @glint-expect-error: Incorrect type }}
      {{#let (component (ensureSafeComponent @triggerComponent)) as |Trigger|}}
        <Trigger
          {{! @glint-expect-error: Incorrect type }}
          @extra={{@extra}}
          @isOpen={{this.isOpen}}
          {{! @glint-expect-error: Incorrect type }}
          @label={{@label}}
          {{! @glint-expect-error: Incorrect type }}
          @selected={{@selected}}
          @toggleDropdown={{this.toggleDropdown}}
          {{! @glint-expect-error: Incorrect type }}
          ...attributes
        />
      {{/let}}
    </div>
    {{#if this.isOpen}}
      <div
        class="{{this.dropdownClassName}} dropdown-default rounded-dropdown"
        {{didInsert this.attachOutsideClickHandler}}
      >
        {{! @glint-expect-error: Incorrect type }}
        {{yield this.publicAPI}}
      </div>
    {{/if}}
  </template>
}
